import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import DarkThemeToggler from "../../components/DarkThemeToggler";
import DemoVideoPage from "../../components/DemoVideoComponent";
import GetStarted from "../../components/GetStarted";
import PreLogin from "../../components/Layouts/PreLogin";
import useDarkmode from "../../utils/utilityHooks/useDarkmode";

const DemoVideo = () => {
  const { theme, themeToggler } = useDarkmode();
  const location = useLocation();

  useEffect(() => {
    location.pathname === "/get-started" &&
      document.body.classList.add("small-header");
    return () => {
      document.body.classList.remove("small-header");
    };
  }, [location.pathname]);

  return (
    <>
      <PreLogin hasFooter={false}>
        <DemoVideoPage />
      </PreLogin>
      <DarkThemeToggler theme={theme} toggleTheme={themeToggler} />
    </>
  );
};

export default DemoVideo;
